// İstemci hata raporu (/v1/client-errors): yakalanmamış hatalar en iyi çabayla bildirilir; oturum başına en çok 10,
// aynı ileti bir kez. Kişisel veri gönderilmez (yalnız ileti, yığın ve ekran yolu).
export type ErrorApp = 'console' | 'admin' | 'passenger' | 'driver' | 'website';

const seen = new Set<string>();

export function reportClientError(
  baseUrl: string,
  app: ErrorApp,
  err: unknown,
  extra: { route?: string; appVersion?: string } = {},
): void {
  const e = err instanceof Error ? err : new Error(typeof err === 'string' ? err : 'Bilinmeyen hata');
  const key = e.message.slice(0, 120);
  if (seen.has(key) || seen.size >= 10) return;
  seen.add(key);
  void fetch(`${baseUrl}/v1/client-errors`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      app,
      message: e.message.slice(0, 500) || 'Bilinmeyen hata',
      stack: e.stack?.slice(0, 4000),
      ...extra,
    }),
  }).catch(() => undefined);
}

/** Tarayıcı: window `error` ve `unhandledrejection` olaylarını raporlar. */
export function installBrowserErrorReporting(baseUrl: string, app: ErrorApp, appVersion?: string): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('error', (ev) =>
    reportClientError(baseUrl, app, ev.error ?? ev.message, { route: location.pathname, appVersion }),
  );
  window.addEventListener('unhandledrejection', (ev) =>
    reportClientError(baseUrl, app, ev.reason, { route: location.pathname, appVersion }),
  );
}
